<!-- @format -->

<template>
	<div class="script-area">
		<div class="script-template">({{ Object.keys(scriptConfig!.getFuncInput()).join(',') }})=>{</div>
		<pc-ace-builds v-model:value="value" :snippets="snippets" language="javascript" />
		<div class="script-template">}</div>
	</div>
</template>
<script setup lang="ts">
	import ScriptList from '../../utils/script';
	import { useBaseConfigStoreWithOut } from '../../config/widget';
	import { PcAceBuilds } from '@/components';

	interface Props {
		modelValue: string;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const scriptConfig = inject<ScriptList>('scriptConfig');

	const name = inject<string>('name');

	const baseConfigStore = useBaseConfigStoreWithOut(name);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const snippets = computed(() => [...baseConfigStore.getScriptSnippets(), ...scriptConfig!.getScriptSnippets()]);
</script>
<style lang="scss" scoped>
	.script-area {
		width: 100%;
		height: 100%;
	}

	.ace-editor {
		min-height: 300px;
	}

	.script-template {
		font-size: 12px;
		padding: 5px;
		background-color: #ebebeb;
	}
</style>
